module.exports = __webpack_public_path__ + "static/subpages-affordability-mobile.7c029252.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/mobile/subpages-affordability-mobile.jpg
// module id = 596
// module chunks = 126523225082832